module.exports = __webpack_public_path__ + "media/scholarship_winners/andy-sw-6ce3151f.png";